export default __webpack_public_path__ + "static/media/QF_Banner.34efde2a.png";